import type { RoomLine, RoomMember, RoomReaction } from '../api';

/** The quick bar when the page carries no set (a server from before 2026-10-19 never reaches here, but the type allows it). */
export const QUICK_FALLBACK = ['❤️', '👋', '💡', '🙏', '😂'];
export const QUICK_COUNT = 5;

/**
 * A line's emoji after `name` chose `emoji` (null: took theirs off) — one per person per line
 * (小屋留人需求 需求四). Idempotent: the room's own event for this person's tap lands after the
 * tap was already drawn, and applying it again changes nothing.
 */
export function withReaction(list: RoomReaction[] | undefined, name: string, emoji: string | null, myName: string): RoomReaction[] {
  const out: RoomReaction[] = [];
  for (const r of list ?? []) {
    const by = r.by.filter((n) => n !== name);
    if (by.length) out.push({ ...r, by, count: by.length, mine: by.includes(myName) });
  }
  if (emoji) {
    const at = out.findIndex((r) => r.emoji === emoji);
    if (at >= 0) { const by = [...out[at].by, name]; out[at] = { ...out[at], by, count: by.length, mine: by.includes(myName) }; }
    else out.push({ emoji, count: 1, mine: name === myName, by: [name] });
  }
  return out;
}

/** The lines with one line's emoji replaced. */
export function setLineReactions(lines: RoomLine[], lineId: string, next: (cur: RoomReaction[] | undefined) => RoomReaction[]): RoomLine[] {
  return lines.map((l) => (l.id === lineId ? { ...l, reactions: next(l.reactions) } : l));
}

/**
 * Where each of the others has read to (需求三): line id → the members whose avatar sits on it —
 * on the newest line at or before their cursor that is a member's or Ember's and not their own
 * (their own words are already theirs; a room notice is no place for a face). Ember shows none.
 */
export function readersByLine(lines: RoomLine[], members: RoomMember[]): Map<string, RoomMember[]> {
  const out = new Map<string, RoomMember[]>();
  const spoken = lines.filter((l) => l.kind === 'human' || l.kind === 'host');
  for (const m of members) {
    if (m.me || !m.read_seq) continue;
    let at: RoomLine | undefined;
    for (const l of spoken) {
      if (l.seq > m.read_seq) break;
      if (!(l.kind === 'human' && l.author === m.name)) at = l;
    }
    if (at) out.set(at.id, [...(out.get(at.id) ?? []), m]);
  }
  return out;
}
